import loginStyle from "../../../../../../assets/scss/common/modal/loginModal.module.scss";
import memberStyle from "../../../../../../assets/scss/sub/editMember.module.scss";
import React, {RefObject, useState} from "react";
import {Address} from "../../../../../../types/user";
import {Option} from "../../../../../../types/signup";
import {useDaumPostcodePopup} from "react-daum-postcode";
import {SignupForeignAddressField} from "./SignupForeignAddressField";
import {StyleRequestType} from "../../../../../../types/common";
import {useTranslation} from "react-i18next";

interface Props{
  address: Address;
  setAddress: (_: Address) => void;
  showNation: boolean;
  setShowNation: (_: boolean) => void;
  styleRequestType:StyleRequestType;
  addressRef?: RefObject<HTMLDivElement>;
  addressDetailRef?: RefObject<HTMLInputElement>;
  foreignAddressDetailRef?: RefObject<HTMLInputElement>;
}
export function SignupAddressField(
    {address, setAddress, showNation, setShowNation,
      styleRequestType, addressRef, addressDetailRef, foreignAddressDetailRef
    }:Props){
  const { t } = useTranslation("userInfo");
  const styles = styleRequestType === StyleRequestType.SIGN_UP ? loginStyle :  memberStyle;
  const [nation, setNation] = useState(styleRequestType === StyleRequestType.SIGN_UP ? "" : address.country);

  const nationOptions: Option[] = [
    { key: '', value: t('form.nation.none')},
    { key: 'KR', value: t('form.nation.kr')},
    { key: 'US', value: t('form.nation.us')},
    { key: 'MN', value: t('form.nation.mn')},
    { key: 'TW', value: t('form.nation.tw')},
    { key: 'VN', value: t('form.nation.vn')},
  ];

  const handleOptionClick = (option: Option) => {
    setNation(option.key);
    setAddress({
      address1: '',
      address2: '',
      address3: '',
      city: '',
      state: '',
      country: option.key,
      postalCode: '',
    });
    setShowNation(false);
  };
  const nationality = address.country;

  const open = useDaumPostcodePopup();
  const onClickFindingAddress = () => {
    open({
      onComplete: (data) => {
        const { sido, sigungu, address, zonecode } = data;
        const addr1 = address.replace(sido, "").replace(sigungu, "").trim();
        setAddress({
          address1: addr1,
          address2: "",
          city: sigungu,
          state: sido,
          postalCode: zonecode,
          country:nation,
        })
        setAddress({
          country:nation,
          address1: addr1,
          address2: "",
          city: sigungu,
          state: sido,
          postalCode: zonecode,
        });
      },
    }).then();
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    setAddress({
      ...address,
      address2: value
    });
  };

  const addressByLanguage = () => {
    if(address.country === ''){
      <></>
    } else if (address.country === 'KR') {
      return (
          <>
            <div className={styles.addressWrapper}>
              <div className={styles.address} ref={addressRef}>
                {address.city === '' ? (
                    <span className={styles.addressText}>
                                    {t("form.address.placeholder.address")}
                                </span>
                ) : (
                    <span className={`${styles.addressText} ${styles.selected}`}>
                                    {address.state} {address.city} {address.address1}
                                </span>
                )}
              </div>
              <div className={styles.addressSearchBtn} onClick={onClickFindingAddress}>
                            <span className={styles.addressSearchText}>
                                {t("form.address.findBtn")}
                            </span>
              </div>
            </div>
            <div className={styles.inputWrapper}>
              <input
                  ref={addressDetailRef}
                  type="name"
                  className={styles.addressInput}
                  value={address.address2 || ''}
                  onInvalid={(e) => e.preventDefault()}
                  onChange={handleInputChange}
                  placeholder={t("form.address.placeholder.addressDetail")}
              />
            </div>
          </>
      );
    } else {
      return (
          <>
            <SignupForeignAddressField title={'State'} setValue={setAddress} address={address}
                                       addressRef={addressRef} foreignAddressRef={foreignAddressDetailRef}
                                       styleRequestType={styleRequestType}
            />
            <SignupForeignAddressField title={'City'} setValue={setAddress} address={address}
                                       addressRef={addressRef} foreignAddressRef={foreignAddressDetailRef}
                                       styleRequestType={styleRequestType}/>
            <SignupForeignAddressField title={'Zip code'} setValue={setAddress} address={address}
                                       addressRef={addressRef} foreignAddressRef={foreignAddressDetailRef}
                                       styleRequestType={styleRequestType}/>
            <SignupForeignAddressField title={'Address1'} setValue={setAddress} address={address}
                                       addressRef={addressRef} foreignAddressRef={foreignAddressDetailRef}
                                       styleRequestType={styleRequestType}/>
            <SignupForeignAddressField title={'Address2'} setValue={setAddress} address={address}
                                       addressRef={addressRef} foreignAddressRef={foreignAddressDetailRef}
                                       styleRequestType={styleRequestType}/>
          </>
      );
    }
  };

  return (
      <div className={styles.selectWrapper}>
        <div className={styles.selectTitleWrapper}>
          <span className={styles.unHighLight}>{t('form.optional')}</span>
          <span className={styles.titleText}>{t('form.address.label')}</span>
        </div>

        <div className={styles.selectTextFieldWrapper} onClick={() => setShowNation(!showNation)}>
          <span className={`${styles.selectText} ${address.country === '' ? styles.unSelected : ''}`}>
            {nationOptions ? nationOptions.find(option => option.key === address.country)?.value
                : t('form.address.placeholder')}
          </span>
          <div className={styles.arrowImg}></div>
          {showNation && (
              <div className={`${styles.optionStyle}  ${styles.nationStyle}`}>
                {nationOptions.map((option) => (
                    <button
                        key={option.key}
                        className={`${styles.optionTextWrapper} ${option.key === nationality ? styles.selectedOption : ''}`}
                        onClick={() => handleOptionClick(option)}>
                                <span className={`${styles.optionText} ${option.key === nationality ? styles.selectedOption : ''}`}>
                                    {option.value}
                                </span>
                    </button>
                ))}
              </div>
          )}
        </div>
        {addressByLanguage()}
      </div>
  )
}